<template>
  <div
    v-if="!isHideTopBar"
    class="header header2 header3"
    :class="{ hide: hideHeader }"
  >
    <div class="wp-header">
      <a
        href="/"
        target="_blank"
        class="logo"
        title="迅雷"
        @click="$util.clickStat(`YXY/LOGO`, `游戏页/标识`)"
      ></a>
      <div
        class="server"
        @click="
          showPanel = !showPanel
          showPanel && $util.clickStat(`YXY/XF`, `游戏页/选服`)
        "
      >
        <span class="title ellipsis-1" :title="gameInfo.title">{{
          gameInfo.title
        }}</span>
        <span class="server-name">{{ curServer.title }}</span>
        <span class="menu"></span>
        <div v-show="showPanel" class="menu-panel clearfix">
          <span
            v-for="(item, i) in serverList"
            :key="item.server_id"
            :class="{ cur: checkCur(item, i) }"
            @click.stop="changeServer(item)"
          >
            {{ item.title }}
            <i v-if="item.flag" :class="item.flag">{{
              $util.flagName(item.flag)
            }}</i>
          </span>
          <span v-if="serverList.length > 20">
            <a
              class="more"
              href="javascript:;"
              @click="$util.clickStat(`YXY/XF/GD`, `游戏页/选服/更多`)"
              >更多&gt;</a
            >
          </span>
        </div>
      </div>
      <div v-if="noticeList.length !== 0" id="broadcast">
        <ul
          :style="{
            top: `${rollSize}px`,
            transition: `top ${useAnimate ? '0.6s' : '0s'} ease 0s`
          }"
        >
          <li v-for="(item, index) in noticeList" :key="item.id + '' + index">
            <span
              @mouseover="switchNoticeRollAnimate(true)"
              @mouseout="switchNoticeRollAnimate()"
              @click="skipGameWebsiteNotice(item.id)"
              >{{ item.title }}</span
            >
          </li>
        </ul>
      </div>
      <ul class="header-nav">
        <li class="nav-user">
          <UserInfo :logout="false" />
        </li>
        <li v-if="topToolbarAdConf.Name" class="nav-custom">
          <a
            :href="topToolbarAdConf.JumpUrl"
            target="_blank"
            @click="$util.clickStat(`YXY/ZDY`, `游戏页/自定义`)"
            >{{ topToolbarAdConf.Name }}</a
          >
        </li>
        <li>
          <a
            href="https://wan.xunlei.com/rules"
            target="_blank"
            @click="$util.clickStat(`YXY/WJSZ`, `游戏页/玩家守则`)"
            >玩家守则</a
          >
        </li>
        <li>
          <a
            href="/"
            target="_blank"
            @click="$util.clickStat(`YXY/YXZX`, `游戏页/游戏中心`)"
            >游戏中心</a
          >
        </li>
        <li>
          <a
            :href="
              `/recharge?game_id=${$route.params.game_id}&server_id=${
                $route.query.server_id
              }&referfrom=${$route.query.referfrom || ''}&actfrom=${$route.query
                .actfrom || ''}`
            "
            target="_blank"
            @click="$util.clickStat(`YXY/TAGCZ`, `游戏页/TAG充值`)"
            >充值</a
          >
        </li>
        <li>
          <a
            href="/customer"
            target="_blank"
            @click="$util.clickStat(`YXY/KF`, `游戏页/客服`)"
            >客服</a
          >
        </li>
        <li>
          <a
            href="./gift"
            target="_blank"
            @click="$util.clickStat(`YXY/LB`, `游戏页/礼包`)"
            >礼包</a
          >
        </li>
        <li v-if="$store.state.game.info.jump_url">
          <a
            :href="$store.state.game.info.jump_url"
            style="color: red"
            target="_blank"
            @click="$util.clickStat(`YXY/WDXZ`, `游戏页/微端下载`)"
            >微端下载</a
          >
        </li>
        <li>
          <a
            href="javascript:;"
            @click="
              addFav()
              $util.clickStat(`YXY/SC`, `游戏页/收藏`)
            "
            >收藏游戏中心</a
          >
        </li>
      </ul>
    </div>
    <i
      class="toggle-icon"
      :title="hideHeader ? '显示顶部栏' : '收起顶部栏'"
      @click="
        hideHeader = !hideHeader
        hideHeader
          ? $util.clickStat(`YXY/YC`, `游戏页/隐藏`)
          : $util.clickStat(`YXY/ZX`, `游戏页/展现`)
      "
    ></i>
  </div>
  <div v-else class="hide"></div>
</template>

<script>
import { mapMutations } from 'vuex'
import UserInfo from '../logic-common/MinUserInfo'
import { getUrlParam } from '~/utils/util'
export default {
  components: {
    UserInfo
  },
  data() {
    return {
      showPanel: false,
      gameInfo: {},
      curServer: {},
      hideHeader: false,
      isHideTopBar: true,
      noticeList: [],
      timeout: 0,
      rollSize: 0,
      topToolbarAdConf: {},
      useAnimate: true
    }
  },
  computed: {
    serverList() {
      return this.gameInfo.server_list || []
    }
  },
  watch: {
    curServer(val = {}) {
      if (process.client) {
        document.title = `迅雷游戏-${val.game_title}-${val.title}`
      }
    }
  },
  created() {
    if (process.client) {
      this.$request('cateServerList', {
        body: { game_id: this.$route.params.game_id }
      }).then((data = []) => {
        this.gameInfo = data[0] || {}
        this.setCurGameName(this.gameInfo)
      })
    }
    /* 顶部自定义 */
    if (process.client) {
      Promise.all([
        this.$request('gameTopToolbarAd'),
        this.$request('getTime')
      ]).then(([data, timeRes]) => {
        if (data && data.Name && timeRes.time) {
          const nowTime = timeRes.time
          if (
            data.StartTime &&
            (this.$dayjs(nowTime).isAfter(this.$dayjs(data.StartTime)) ||
              this.$dayjs(nowTime).isSame(this.$dayjs(data.StartTime))) &&
            data.EndTime &&
            this.$dayjs(nowTime).isBefore(this.$dayjs(data.EndTime))
          ) {
            this.topToolbarAdConf = data
            const countDown = this.$dayjs(data.EndTime).diff(
              this.$dayjs(nowTime)
            )
            setTimeout(() => {
              this.topToolbarAdConf = {}
            }, countDown)
          }
        }
      })
    }
  },
  mounted() {
    this.getLeftBarStatus()
    this.getNoticeList()
  },
  methods: {
    ...mapMutations('player', ['setCurServer', 'setCurGameName']),
    getLeftBarStatus() {
      const isHideTopBar = getUrlParam('hideTopBar') || false
      this.isHideTopBar = isHideTopBar
    },
    getNoticeList() {
      this.$request('gameHomeRes', {
        body: {
          game_id: this.$route.params.game_id,
          res_type: 1,
          page: 1,
          page_size: 3
        }
      }).then((res = {}) => {
        const list = JSON.parse(JSON.stringify(res)).list || []
        if (list.length > 1) {
          list.push(list[0])
        }
        this.$set(this, 'noticeList', list)
        this.switchNoticeRollAnimate()
      })
    },
    checkCur(item, i) {
      if (item.server_id === +this.$route.query.server_id) {
        this.curServer = item
        this.$store.commit('play/setCurServer', item)
        return true
      }
      return false
    },
    addFav() {
      try {
        window.external.addFavorite(location.href, document.title)
      } catch (e) {
        try {
          window.sidebar.addPanel(location.href, document.title, '')
        } catch (e) {
          alert(
            '抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加'
          )
        }
      }
    },
    goRecharge() {
      this.$router.push({
        path: '/recharge',
        query: {
          game_id: this.$route.params.game_id,
          server_id: this.$route.query.server_id
        }
      })
    },
    changeServer(params) {
      this.showPanel = false
      const { game_id, server_id } = params
      this.$util.gameStat(
        game_id,
        server_id,
        `YXY/XF/JRYX`,
        `游戏页/选服/进入游戏`
      )
    },
    switchNoticeRollAnimate(stop = false) {
      if (stop || this.noticeList.length === 1) {
        clearTimeout(this.timeout)
        return
      }
      this.timeout = setTimeout(() => {
        this.$set(this, 'useAnimate', true)

        const top = this.rollSize - 28
        this.$set(this, 'rollSize', top)

        if ((this.noticeList.length - 1) * -28 === top) {
          setTimeout(() => {
            this.$set(this, 'useAnimate', false)
            this.$set(this, 'rollSize', 0)
          }, 1000)
        }

        this.switchNoticeRollAnimate()
      }, 5000)
    },
    skipGameWebsiteNotice(noticeId) {
      window.open(
        location.origin +
          `/game-offical/${this.$route.params.game_id}/notice/${noticeId}`
      )
    }
  }
}
</script>
<style scoped>
.header.header2.header3 .wp-header {
  width: 100%;
  padding-left: 22px;
  padding-right: 62px;
  box-sizing: border-box;
}

#broadcast {
  float: left;
  width: 358px;
  height: 28px;
  line-height: 28px;
  padding-left: 34px;
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 40px;
  position: relative;
  transition: all 0.6s;
  overflow: hidden;
}

#broadcast:before {
  content: '';
  display: inline-block;
  position: absolute;
  width: 28px;
  height: 28px;
  background: url(~assets/img/common/broadcast-icon.png);
  background-size: 28px 28px;
  left: 0;
  top: 0;
}

#broadcast ul {
  position: relative;
  transition: top 0.6s;
}

#broadcast ul li {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
}

#broadcast ul li span {
  text-decoration: underline;
}

#broadcast ul li span:hover {
  color: #f37713;
  cursor: pointer;
}
</style>
